<template>
  <div>
    <div class="d-flex">
      <div class="parent-item" :class="item.parent ? '' : 'ps-5'">
        <div v-if="item.parent" class="d-flex w-100">
          <div
            class="bg-primary p-2 rounded-circle text-light"
            style="cursor: pointer"
            @click="toggle"
          >
            <i
              :class="!isOpen ? `fe fe-chevron-right` : `fe fe-chevron-down`"
            ></i>
          </div>
          <input
            type="text"
            v-model="item.name"
            class="ml-2 w-100"
            style="border: none"
          />
        </div>
        <div v-else>
          <input type="text" v-model="item.name" style="border: none" />
        </div>
      </div>
      <div
        class="d-flex text-center justify-content-center"
        style="gap: 50px"
        v-if="item.parent"
      >
        <template v-if="isOpen">
          <div
            class="column-item"
            v-for="(column, i) in columns"
            :key="`column_label_${i}`"
          >
            {{ column.label }}
          </div>
          <div class="">
            <i
              class="fe fe-plus-circle text-secondary"
              style="cursor: pointer"
            ></i>
          </div>
        </template>
      </div>
      <div class="d-flex" style="gap: 50px" v-else>
        <div
          class="column-item"
          v-for="(column, i) in columns"
          :key="`column_data_${i}`"
        >
          <button class="btn btn-link" v-if="column.type === 'BUDGET'">
            <i class="fe fe-clipboard"></i>
          </button>
          <v-date-picker
            v-if="column.type === 'DATE'"
            v-model="date"
            :attributes="attrs"
          >
            <template #default="{ togglePopover }">
              <button class="btn btn-link" @click="togglePopover">
                <i class="fe fe-calendar"></i>
              </button>
            </template>
          </v-date-picker>
          <div v-if="column.type === 'TEXT'">
            <input type="text" class="w-100" style="border: none" />
          </div>
        </div>
      </div>
    </div>
    <div v-show="isOpen" v-if="item.parent">
      <TreePlan
        class="item"
        v-for="(child, index) in item.children"
        :key="index"
        :item="child"
        :columns="columns"
        @make-folder="$emit('make-folder', $event)"
        @add-item="$emit('add-item', $event)"
      ></TreePlan>
      <div class="add ps-5 border-top">
        <small
          class="text-secondary"
          @click="$emit('add-item', item)"
          style="cursor: pointer"
        >
          + New Item
        </small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TreePlan",
  props: {
    item: Object,
    columns: Array,
  },
  data() {
    return {
      isOpen: false,
      date: null,
      attrs: [
        {
          key: "today",
          dot: true,
          dates: new Date(),
        },
      ],
    };
  },
  computed: {
    isFolder: function () {
      return this.item.children && this.item.children.length;
    },
  },
  methods: {
    toggle() {
      if (this.isFolder) {
        this.isOpen = !this.isOpen;
      }
    },
    makeFolder() {
      if (!this.isFolder) {
        this.$emit("make-folder", this.item);
        this.isOpen = true;
      }
    },
  },
};
</script>

<style>
.parent-item {
  display: flex;
  align-items: center;
  width: 50rem;
}
.column-item {
  display: flex;
  align-items: center;
  width: 160px;
  overflow: hidden;
  justify-content: center;
  align-content: center;
  text-align: center;
  margin: auto;
}
</style>
